











































































































import { Vue, Component } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { UpdatePasswordData, User } from '@/interfaces/UserInterfaces'
import UserService from '@/services/UserService'

@Component({ name: 'ChangePasswordForm' })
export default class ChangePasswordForm extends Vue {
  @Getter('user/currentUser')
  user!: User

  error: string | null = null

  passwordForm: UpdatePasswordData = {
    oldPassword: '',
    newPassword: ''
  }

  repeatPassword: string = ''
  isPasswordChanged: boolean = false

  async changePassword () : Promise<void> {
    this.error = null
    this.errors.clear()

    if (!await this.$validator.validateAll()) {
      this.$el.querySelector('.error')!.scrollIntoView(false)
      return
    }

    try {
      const response = await UserService.changePassword(this.user.id, this.passwordForm)

      this.$validator.pause()
      this.passwordForm.oldPassword = ''
      this.passwordForm.newPassword = ''
      this.repeatPassword = ''

      await this.$auth.setToken(response)

      this.isPasswordChanged = true
      setTimeout(() => {
        this.isPasswordChanged = false
      }, 3000)
    } catch (error) {
      if ('response' in error && error.response.status === 400) {
        this.handleChangePasswordErrors(error.response.data, this.passwordForm)
      } else {
        throw error
      }
    }
  }

  handleChangePasswordErrors (response: any, formData: object) : void {
    this.error = response.message

    Object.keys(response.errors).forEach((value: string) => {
      if (formData.hasOwnProperty(value) && value in response.errors && response.errors[value][0]) {
        this.errors.add({
          field: value,
          msg: response.errors[value][0]
        })
      }
    })
  }

  resetChangePasswordForm () : void {
    this.$validator.pause()
    this.errors.clear()
    this.passwordForm.oldPassword = ''
    this.passwordForm.newPassword = ''
    this.repeatPassword = ''
  }
}
